import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { MDBTable, MDBTableBody, MDBTableHead } from "mdb-react-ui-kit";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import { fetchRewardWithdrawals } from "../../actions/referralActions";
import { downloadBtnStyle, downloadCSV, getDynamicKeys, toTitleCase } from "./shared";

const RewardWithdrawals = () => {
  const dispatch = useDispatch();
  const [withdrawalsPage, setWithdrawalsPage] = useState(1);
  const [filterReferrerId, setFilterReferrerId] = useState("");
  const [filterStatusId, setFilterStatusId] = useState("");

  const { loading, data, error } = useSelector((state) => state.getRewardWithdrawals) || {};
  const withdrawals = data?.data;
  const dynamicKeys = getDynamicKeys(withdrawals?.items || []);

  const handleFilter = () => {
    setWithdrawalsPage(1);
    dispatch(fetchRewardWithdrawals(1, 100, filterReferrerId || null, filterStatusId || null));
  };

  const handlePageChange = (page) => {
    setWithdrawalsPage(page);
    dispatch(fetchRewardWithdrawals(page, 100, filterReferrerId || null, filterStatusId || null));
  };

  const handleDownload = () => {
    if (!withdrawals?.items?.length) {
      toast.warning("No data to download");
      return;
    }
    downloadCSV(
      "reward_withdrawals",
      dynamicKeys.map(toTitleCase),
      withdrawals.items.map((item) => dynamicKeys.map((k) => item[k] ?? "")),
    );
  };

  if (loading) return <Loader />;
  if (error) return <p className="text-danger text-center">{error}</p>;

  return (
    <>
      <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginBottom: "16px", alignItems: "flex-end" }}>
        <div>
          <label style={{ display: "block", fontSize: "12px", color: "#aaa", marginBottom: "4px" }}>Referrer ID</label>
          <input value={filterReferrerId} onChange={(e) => setFilterReferrerId(e.target.value)} placeholder="Filter by referrer ID" style={{ padding: "8px 12px", border: "1px solid #444", borderRadius: "6px", background: "#1a1a1a", color: "#fff", fontSize: "13px", width: "180px" }} />
        </div>
        <div>
          <label style={{ display: "block", fontSize: "12px", color: "#aaa", marginBottom: "4px" }}>Status ID</label>
          <input value={filterStatusId} onChange={(e) => setFilterStatusId(e.target.value)} placeholder="Filter by status ID" style={{ padding: "8px 12px", border: "1px solid #444", borderRadius: "6px", background: "#1a1a1a", color: "#fff", fontSize: "13px", width: "160px" }} />
        </div>
        <button onClick={handleFilter} style={{ padding: "8px 18px", background: "#007bff", color: "#fff", border: "none", borderRadius: "6px", cursor: "pointer", fontWeight: "600", fontSize: "13px" }}>
          Filter
        </button>
        <button onClick={handleDownload} style={{ ...downloadBtnStyle, marginLeft: "auto" }}>
          ⬇ Download CSV
        </button>
      </div>

      <MDBTable responsive style={{ width: "100%", fontSize: "14px" }}>
        <MDBTableHead>
          <tr>
            {dynamicKeys.length > 0 ? (
              dynamicKeys.map((key) => <th key={key}>{toTitleCase(key)}</th>)
            ) : (
              <th>No Data</th>
            )}
          </tr>
        </MDBTableHead>
        <MDBTableBody>
          {withdrawals?.items?.length > 0 ? (
            withdrawals.items.map((item, idx) => (
              <tr key={item.id || idx}>
                {dynamicKeys.map((key) => (
                  <td key={key}>{item[key] != null ? String(item[key]) : "-"}</td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={Math.max(dynamicKeys.length, 1)} style={{ textAlign: "center", padding: "20px" }}>No reward withdrawals found</td>
            </tr>
          )}
        </MDBTableBody>
      </MDBTable>

      {withdrawals?.page?.total_page > 1 && (
        <div style={{ display: "flex", gap: "8px", justifyContent: "center", marginTop: "16px" }}>
          {Array.from({ length: withdrawals.page.total_page }, (_, i) => i + 1).map((page) => (
            <button key={page} onClick={() => handlePageChange(page)} style={{ padding: "6px 12px", border: "1px solid #444", borderRadius: "4px", background: withdrawalsPage === page ? "#007bff" : "#1a1a1a", color: "#fff", cursor: "pointer" }}>
              {page}
            </button>
          ))}
        </div>
      )}
    </>
  );
};

export default RewardWithdrawals;
